import { Page } from 'components/Page';
// import { Box } from '@mui/material';


export const Contact = () => <Page title="Contact Us"> 
hello

</Page>